<template>
    <div class="media position--relative">
        <!-- eslint-disable max-len -->
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="89.238"
            height="89.238"
            viewBox="0 0 89.238 89.238"
            role="img"
            :aria-label="$t('accessibility.play')"
        >
            <defs>
                <filter id="a" x="0" y="0" width="89.238" height="89.238" filterUnits="userSpaceOnUse">
                    <feOffset input="SourceAlpha"/>
                    <feGaussianBlur stdDeviation="3" result="b"/>
                    <feFlood flood-opacity="0.039"/>
                    <feComposite operator="in" in2="b"/>
                    <feComposite in="SourceGraphic"/>
                </filter>
            </defs>
            <g transform="translate(9 9)">
                <g class="b" transform="matrix(1, 0, 0, 1, -9, -9)" filter="url(#a)">
                    <path class="a" d="M35.619,0A35.619,35.619,0,1,1,0,35.619,35.619,35.619,0,0,1,35.619,0Z" transform="translate(9 9)" fill="#fff"/>
                </g>
            </g>
        </svg>
        <div
            :class="[
                'media__control position--absolute display--flex',
                { 'js--active': isPause }
            ]"
        >
            <div class="media__control__shape media__control__shape--one"></div>
            <div class="media__control__shape media__control__shape--two"></div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        isPause: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style lang="scss">
    // =============================================================================
    // Variables
    // =============================================================================
    $active-class: '.js--active';

    .media {
        width: max-content;
        &__control {
            @include transform-position( 47%, false, false, 49%, translate( -50%, -50% ) );
            @include position-grid( center, center );
            flex-direction: row;
            &__shape {
                @include dimensions( 15px, 27px );
                background: $color-grey-dark;
                @include transition( all .3s ease-in-out );
                &--one {
                    clip-path: polygon( 45% 15%, 95% 15%, 95% 85%, 45% 85% );
                    @include transform( translateX( 0 ) );
                }
                &--two {
                    clip-path: polygon( 25% 15%, 75% 15%, 75% 85%, 25% 85% );
                    @include transform( translateX( 0 ) );
                }
            }
            &#{$active-class} & {
                &__shape {
                    background: $color-yellow;
                    &--one {
                        height: 40px;
                        clip-path: polygon( 0 0, 100% 25%, 100% 75%, 0% 100% );
                        @include transform( translateX( 5px ) );
                    }
                    &--two {
                        height: 45px;
                        clip-path: polygon( 0 25%, 100% 50%, 100% 50%, 0 75% );
                        @include transform( translateX( 3.5px ) );
                    }
                }
            }
        }
    }
</style>